import { Button } from "@react-md/button";
import styles from "./options.module.scss";
import variables from "../../../styles/variables.module.scss";
import { useNavigate } from "react-router-dom";
import { useT } from "../../../i18n";

const Options = () => {
  const navigate = useNavigate();
  const t = useT();
  const titles = [t("home.step1"), t("home.step2"), t("home.step3")];
  return (
    <div className={`${styles.container} ${variables.row}`}>
      <div className={`${styles.title} ${variables.row}`}>
        <span className={variables.textSm}>{t("home.createNfc")}</span>
        <span className={variables.textSm}>{t("home.createStyle")}</span>
      </div>
      {titles.map((e, index) => (
        <div className={`${styles.option} ${variables.row}`} key={e}>
          <span>{index + 1}</span>
          <span className={variables.title}>{e}</span>
        </div>
      ))}
      <Button
        className={variables.containedBtn}
        onClick={() => navigate("/shop")}
        themeType="contained"
      >
        {t("home.getStarted")}
      </Button>
    </div>
  );
};

export default Options;
